// extracted by mini-css-extract-plugin
export default {"reg":"styles_reg__eCj2U","body":"styles_body__cJGXt","left":"styles_left__YZneP"};